import React, { useState, useRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { AiOutlineCalendar } from 'react-icons/ai';
import { useClickAway } from 'react-use';

const CustomMonthYearPicker = ({ date, setDate, setIsFiltered, formatDate }) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const calendarRef = useRef(null);

  useClickAway(calendarRef, () => setIsCalendarOpen(false));

  const handleDateChange = (selectedDate) => {
    if (selectedDate) {
      const formattedDate = formatDate(selectedDate); // Format the selected date
      setDate(formattedDate); // Set the date state to formatted date (with day '01')
      setIsFiltered(true); // Mark the filter as applied
      setIsCalendarOpen(false);
    }
  };

  return (
    <div className="relative inline-block" ref={calendarRef}>
      <div
        className="flex items-center text-center cursor-pointer p-1 px-2 border border-gray-300 rounded-md"
        onClick={() => setIsCalendarOpen(!isCalendarOpen)}
      >
        <AiOutlineCalendar className='mr-1' size={16} />
        <div className="text-gray-600 text-[13px] font-inter">
          {date ? new Date(date).toISOString().slice(0, 7) : 'Pick date'}
        </div>
      </div>

      {isCalendarOpen && (
        <div className="absolute mt-2 z-50 shadow-lg">
          <DatePicker
            selected={date ? new Date(date) : null}
            onChange={handleDateChange}
            dateFormat="yyyy-MM"
            showMonthYearPicker
            inline
            className="border px-4 py-2 rounded"
          />
        </div>
      )}
    </div>
  );
};

export default CustomMonthYearPicker;
